function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * add a click listener to toggle a body element class
 *
 * @param {String} activeClass - class to toggle
 * @param {Element|String} el - el to add click listener to
 * @param {Function} call back function after toggling
 */
var BodyClassToggler = function BodyClassToggler() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var activeClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toggler-active';
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  _classCallCheck(this, BodyClassToggler);

  if (typeof el === "string") {
    el = document.querySelector(el);
  }

  if (!el) return;
  el.addEventListener('click', function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    document.body.classList.toggle(activeClass);
    if (cb) cb(evt);
  });
};

export { BodyClassToggler as default };